import config from '../config';

export const generateAssetPath = filename =>
  `${config.BASE_PATH}/assets/${filename}`;
